import api, { createURLParams } from "../../client";
import { QueryParams } from "../../types/base";
import { AccountListResponseData } from "../../types/account";

export const accountsRequest = async (params: QueryParams) => {
  const { data } = await api.get<AccountListResponseData>(
    `/accounts${createURLParams(params)}`,
  );

  return data;
};
